import { Col, Row } from 'reactstrap';
import { TEXT } from 'locales/translations';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getUserPaymentDetails, getUserPaymentMethod } from 'redux/query';

export const SubscriptionDetailPayedWith = () => {
  const { provider, product, canceled, active } = useSelector(getUserPaymentDetails);
  const userPaymentMethod = useSelector(getUserPaymentMethod);

  const paymentMethodType = useMemo(() => {
    if (!userPaymentMethod) {
      return '';
    }
    return userPaymentMethod.type;
  }, [userPaymentMethod]);

  if (!active) {
    return null;
  }

  return (
    <Row className="mt-2">
      <Col xs={12} sm={6} className="subscription-status-title">
        <strong>{TEXT.subscriptionStatusDetail.payWith}</strong>
      </Col>
      <Col xs={12} sm={6}>
        {product.includes('Geschenk-Gutschein') ? (
          <>{product}</>
        ) : (
          <>
            {provider === 'itunes' && <>{TEXT.subscriptionStatusDetail.payWithApple}</>}
            {provider === 'STRIPE' && paymentMethodType === 'card' && <>{TEXT.subscriptionStatusDetail.payWithStripeCard}</>}
            {provider === 'STRIPE' && paymentMethodType === 'sepa_debit' && <>{TEXT.subscriptionStatusDetail.payWithStripeDebit}</>}
            {provider === 'STRIPE' && paymentMethodType === 'paypal' && <>{TEXT.subscriptionStatusDetail.payWithStripePayPal}</>}

            {(provider === 'GOOGLE_PLAY_STORE' || provider === 'GOOGLE_PAYMENT') && <>{TEXT.subscriptionStatusDetail.payWithGoogle}</>}
            {provider === 'BALLOON_VOUCHERS' && <>{TEXT.subscriptionStatusDetail.payWithVoucer}</>}
          </>
        )}
      </Col>
    </Row>
  );
};
